var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"atom-background",class:{'large-corner-radius': _vm.largeCornerRadius}},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"background",style:(_vm.style),attrs:{"aria-hidden":"true"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }